import { Icon } from "@iconify/react";
import Breadcrumbs from "components/Breadcrumbs";
import DownloadRow from "components/DownloadRow";
import SEO from "components/SEO";
import Text from "components/Text";
import SessionContext from "components/session/SessionContext";
import { pagePadding } from "data/commonClasses";
import { useContext } from "react";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

export default function Arbitration({ categories, laws }) {
  const { t } = useTranslation();

  let {
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang === "ar";

  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t("arbitrationCenter") },
  ];

  let arbitrationDetails = [
    {
      title: t("statuteOfArbitration"),
      pdf: "statuteOfArbitration",
    },
    {
      title: t("arbitrationRules"),
      pdf: "arbitrationRules",
    },
    { title: t("arbitrationCosts"), pdf: "arbitrationCosts" },
    {
      title: t("formsAndDocs"),
      subDetails: [
        { title: t("arbitrationClause"), pdf: "arbitrationClause" },
        { title: t("arbitrationRequest"), pdf: "arbitrationRequest" },
        {
          title: t("respondingToArbitrationRequest"),
          pdf: "respondingToArbitrationRequest",
        },
        {
          title: t("arbitrationAcceptance"),
          pdf: "arbitrationAcceptance",
        },
      ],
    },
  ];

  return (
    <div className={twMerge("flex flex-col w-full min-h-screen", pagePadding)}>
      <SEO title={t("arbitration")} description={t("arbitration")} />
      <Breadcrumbs items={breadcrumbs} />
      <div>
        <Text
          text={t("arbitrationCenter")}
          bold
          sectionTitle
          className="mt-5"
        />
      </div>
      <div className={"pt-3 pb-6"}>
        <Text
          text={`
        أنشئ لدى نقابة المهندسين في طرابلس بموجب القرار رقم 2022/114-2023
        تاريخ 26/07/2022، مركز التحكيم الهندسي، مهمته تنظيم التحكيم في
        النزاعات ذات الطابع الهندسي أو الناشئة عن الاتفاقيات المعقودة فيما بين
        المهندسين أو فيما بينهم وبين زبائنهم والتي توافق أطرافها على احالتها
        الى المركز.`}
        />
      </div>
      <div className={"mb-5"}>
        <div className={"flex flex-col "}>
          {arbitrationDetails.map((oneData, index) => {
            let withDetails = oneData?.subDetails?.length;
            return (
              <div key={index}>
                {withDetails ? (
                  <Text
                    text={oneData?.title}
                    bold
                    sectionTitle
                    className="my-5"
                  />
                ) : (
                  <DownloadRow
                    title={oneData?.title}
                    href={`https://oea-tripoli.org.lb/docs/${oneData?.pdf}.pdf`}
                  />
                )}

                {withDetails ? (
                  <div>
                    {oneData?.subDetails.map((data) => (
                      <DownloadRow
                        key={data?.title}
                        title={data?.title}
                        href={`https://oea-tripoli.org.lb/docs/${data?.pdf}.pdf`}
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
